import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';

function* getPerformanceTags({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.analytics.tags, params: { page: curr_page, q: searchQ }, signal });
    yield put(actions.getPerformanceTagsDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPerformanceTagsFailed,
      endpoint: api.analytics.tags.url
    });
  }
}

export const getPerformanceTagsSaga = takeEvery(types.GET_PERFORMANCE_TAGS_REQUEST, getPerformanceTags);

